export const TRACKING_SOURCE = {
  FROM_MESSAGE: "FROM_MESSAGE",
  FROM_LIVE: "FROM_LIVE",
  FROM_VIDEO_CALL: "FROM_VIDEO_CALL",
  FROM_DISCOVER: "FROM_DISCOVER",
  FROM_LIVE_LIST_FAVORITE: "FROM_LIVE_LIST_FAVORITE",
  FROM_LIVE_LIST_LOVENSE: "FROM_LIVE_LIST_LOVENSE",
  FROM_LIVE_LIST_FREE_LOVENSE: "FROM_LIVE_LIST_FREE_LOVENSE",
} as const;

export type TrackingSource =
  (typeof TRACKING_SOURCE)[keyof typeof TRACKING_SOURCE];
